module.exports = __webpack_public_path__ + "img/bj.f5abd012.png";